import React from 'react';
import moment from 'moment';

const ModalBody = ({
  memberRole,
  member,
  modalId,
  setMemberRole,
  memberName
}) => {
  const modalBodyForChange = () => (
    <>
      <div>
        <div className="col-md-12 ps-md-0 mb-4">
          <input
            type="radio"
            className="btn-check"
            name="options"
            id="btn-check-1-outlined-modal"
            autoComplete="off"
          />
          <label
            className={`btn btn-outline-primary w-100 ${selected('admin')}`}
            htmlFor="btn-check-1-outlined-modal"
            onClick={() => setMemberRole('admin')}
          >
            Admin
          </label>
        </div>
        <div className="col-md-12 ps-md-0 mb-4">
          <input
            type="radio"
            className="btn-check"
            name="options"
            id="btn-check-2-outlined-modal"
            autoComplete="off"
          />
          <label
            className={`btn btn-outline-primary w-100 ${selected('leader')}`}
            htmlFor="btn-check-2-outlined-modal"
            onClick={() => setMemberRole('leader')}
          >
            Leader
          </label>
        </div>
        <div className="col-md-12 ps-md-0 mb-4">
          <input
            type="radio"
            className="btn-check"
            name="options"
            id="btn-check-3-outlined-modal"
            autoComplete="off"
          />
          <label
            className={`btn btn-outline-primary w-100 ${selected('standard')}`}
            htmlFor="btn-check-3-outlined-modal"
            onClick={() => setMemberRole('standard')}
          >
            Member
          </label>
        </div>
      </div>
      <div>
        <u className="text-primary">Learn more about roles and permissions</u>
      </div>
    </>
  );

  const modalBodyForRemove = () => {
    return (
      <div>
        <p className="fs-5">
          <span className="h4">{memberName}</span> will no longer have access to
          this community and their subscription will be cancelled.
        </p>
      </div>
    );
  };

  const modalBodyForRestart = () => {
    return (
      <div>
        <p className="fs-5">
          <span className="h4">{memberName}</span> will have his subscription restarted.
          This will apply any price changes the subscription may have suffered since <span className="h4">{memberName}</span> has created his subscription
        </p>
      </div>
    );
  };

  const modalBodyForApplication = () => {
    if (!member.applicationDetails) {
      return (
        <div>
          <p className="h3 text-primary">
            {member.displayName}
          </p>
          <p className="h4">
            {member.title}, {member.company}
          </p>
          <p className="h4"> No application on file currently </p>
        </div>
      );
    }

    const { created_at: createdAt, updated_at: updatedAt, details, location, status } =
      member.applicationDetails;
    const { favorite_meal: favoriteMeal, submission_source: submissionSource, who_referred: whoReferred, why } = details;

    return (
      <>
        <div className="border-bottom">
          <p className="h3 text-primary">
            {member.displayName}
          </p>
          <p className="h4">
            {member.title}, {member.company}
          </p>
        </div>
        <div className="ps-4 application-modal">
          <div>
            <label className="fw-bolder">Email</label>
            <p>{member.email}</p>
          </div>
          {member.linkedinUrl && (
            <div>
              <label className="fw-bolder">LinkedIn Url</label>
              <p>{member.linkedinUrl}</p>
            </div>
          )}
          {submissionSource &&
            <div>
              <label className="fw-bolder">Submission source</label>
              <p>{submissionSource}</p>
            </div>
          }
          {whoReferred &&
            <div>
              <label className="fw-bolder">Referred by</label>
              <p>{whoReferred}</p>
            </div>
          }
          {favoriteMeal &&
            <div>
              <label className="fw-bolder">Favorite meal</label>
              <p>{favoriteMeal}</p>
            </div>
          }
          {location &&
            <div>
              <label className="fw-bolder">Location</label>
              <p>{location}</p>
            </div>
          }
          {why &&
            <div>
              <label className="fw-bolder">Why do they want to join?</label>
              <p>{why}</p>
            </div>
          }
          {createdAt &&
            <div>
              <label className="fw-bolder">Created At</label>
              <p>{moment(createdAt).format('ddd, MMM Do YYYY, h:mm:ss a')}</p>
            </div>
          }
          {updatedAt &&
            <div>
              <label className="fw-bolder">Updated At</label>
              <p>{moment(updatedAt).format('ddd, MMM Do YYYY, h:mm:ss a')}</p>
            </div>
          }
        </div>
      </>
    );
  };

  const setModalBodyType = (type) => {
    switch (type) {
      case 'changeRoleModal':
        return modalBodyForChange();
      case 'removeMemberModal':
        return modalBodyForRemove();
      case 'restartSubscriptionModal':
        return modalBodyForRestart();
      case 'applicationModal':
        return modalBodyForApplication();
      default:
        return modalBodyForChange();
    }
  };

  const selected = (status) => {
    return status === memberRole ? 'role-selected' : 'role-unselected';
  };

  return setModalBodyType(modalId);
};

export default ModalBody;
